import { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  Box,
  TextField as MuiTextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag, Checkbox } from '../../../../../components';
import { useRef } from 'react';
import AddIcon from '@mui/icons-material/Add';
import {
  dropdownFetch,
  getCityByState,
  getCurrentDateTime,
  getKeyPathValue,
  getStatesByCountry,
  request,
  toast
} from '../../../../../utils';
import {
  ASSIGNED_SHIFT,
  CURRENT_STATUS,
  DOC_TYPE,
  EMPLOYEE_TYPE,
  GENDER_DROPDOWN,
  REG_LOCATION,
  SALARY_TYPE,
  STAFF_TYPE,
  YES_NO
} from '../../../../../constants';
import { CustomButtonn } from '../../../../../components';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';
import { DepartmentMaster } from '../masters/DepartmentMaster';
import { RoleMaster } from '../masters/RoleMaster';
import { ShiftMaster } from '../masters/ShiftMaster';
import { BASE_URL_FOR_FILE } from '../../../../../utils/BaseUrl';

const TABLE_COLUMNS = [
  {
    header: 'Employee Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.personalInfo?.firstName} ${row?.personalInfo?.lastName} `}
        </span>
      );
    }
  },
  {
    header: 'Gender',
    accessor: (row) => row?.personalInfo?.gender
  },
  {
    header: 'Mobile',
    accessor: (row) => row?.personalInfo?.mobile
  },
  {
    header: 'Department',
    accessor: (row) => row?.workDetails?.department?.name
  },
  {
    header: 'Assigned Shift',
    accessor: (row) => row?.workDetails?.assignedShift?.shiftName
  },
  {
    header: 'Status',
    accessor: (row) => row?.status,
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialDoctorDataObj = {
  data: [],
  loading: false
};

export const EmployeeManagement = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [doctorDataObj, setDoctorDataObj] = useState(initialDoctorDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [roleDropdown, setRoleDropdown] = useState([]);
  const [shiftDropdown, setShiftDropdown] = useState([]);

  const [activeTab, setActiveTab] = useState(0);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [departmentMasterDialogue, setDepartmentMasterDialogue] = useState(false);
  const [roleMasterDialogue, setRoleMasterDialogue] = useState(false);
  const [shiftMasterDialogue, setShiftMasterDialogue] = useState(false);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const user = JSON.parse(localStorage.getItem('user'));
  const [imageFile, setImageFile] = useState({});
  const [imagePreview, setImagePreview] = useState({});
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];

  const fieldOneRef = useRef(null);
  const fieldTwoRef = useRef(null);
  const fieldThreeRef = useRef(null);
  const fieldFourRef = useRef(null);
  const fieldFiveRef = useRef(null);
  const fieldSixRef = useRef(null);
  const fieldSevenRef = useRef(null);
  const fieldEightRef = useRef(null);
  const fieldNineRef = useRef(null);
  const fieldTenRef = useRef(null);
  const fieldElevenRef = useRef(null);

  const handleKeyPress = (e, nextFieldRef) => {
    if (e.key === 'Tab' && nextFieldRef) {
      e.preventDefault();
      nextFieldRef.current.focus();
    }
  };

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('employee-department');
    setDepartmentDropdown(data);
  }, []);
  const getRoleDropdown = useCallback(async () => {
    const data = await dropdownFetch('employee-role');
    setRoleDropdown(data);
  }, []);

  const getShiftDropdown = useCallback(async () => {
    const data = await dropdownFetch('employee-shift');
    setShiftDropdown(data);
  }, []);

  useEffect(() => {
    getDepartmentDropdown();
    getRoleDropdown();
    getShiftDropdown();
  }, [getDepartmentDropdown, getRoleDropdown, getShiftDropdown]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        firstName: Yup.string().required(' '),
        dob: Yup.string().required(' '),
        gender: Yup.string().required(' '),
        WhatsAppNumber: Yup.string().required(' '),
        mobile: Yup.string()
          .required('Mobile number is required')
          .matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits'),
        fatherName: Yup.string().required(' '),
        email: Yup.string().required(' '),
        addressLine1: Yup.string().required(''),
        city: Yup.string().required(' '),
        state: Yup.string().required(' '),
        country: Yup.string().required(' '),
        postalCode: Yup.string().required(' '),
        aadharNumber: Yup.string()
          .required('Aadhar  number is required')
          .matches(/^\d{12}$/, 'Aadhar number must be exactly 12digits'),
        employeeId: Yup.string().required(' '),
        department: Yup.string().required(' '),
        role: Yup.string().required(' '),
        assignedShift: Yup.string().required(' '),
        dateOfJoining: Yup.string().required(' '),
        salaryType: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      country: 'IN'
    },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset, watch } = methods;

  useEffect(() => {
    if (selectedRecord) {
      // Flatten out the fields in selectedRecord that need to be set
      const fieldsToSet = [
        { key: 'aadharNumber', value: selectedRecord?.documents?.aadharNumber },
        { key: 'proofOfAddress', value: selectedRecord?.documents?.proofOfAddress },
        { key: 'proofOfIdentity', value: selectedRecord?.documents?.proofOfIdentity },
        { key: 'WhatsAppNumber', value: selectedRecord?.personalInfo?.WhatsAppNumber },
        {
          key: 'dob',
          value: selectedRecord?.personalInfo?.dob
            ? new Date(selectedRecord.personalInfo?.dob).toISOString().split('T')[0]
            : ''
        },
        { key: 'email', value: selectedRecord?.personalInfo?.email },
        { key: 'fatherName', value: selectedRecord?.personalInfo?.fatherName },
        { key: 'firstName', value: selectedRecord?.personalInfo?.firstName },
        { key: 'gender', value: selectedRecord?.personalInfo?.gender },
        { key: 'lastName', value: selectedRecord?.personalInfo?.lastName },
        { key: 'mobile', value: selectedRecord?.personalInfo?.mobile },
        { key: 'photo', value: selectedRecord?.personalInfo?.photo },

        // Previous Work Details
        { key: 'companyName', value: selectedRecord?.previousWorkDetails?.companyName },
        { key: 'prevDescription', value: selectedRecord?.previousWorkDetails?.description },
        { key: 'reasonForLeaving', value: selectedRecord?.previousWorkDetails?.reasonForLeaving },
        { key: 'role', value: selectedRecord?.previousWorkDetails?.role },
        {
          key: 'prevStartDate',
          value: selectedRecord?.previousWorkDetails?.startDate
            ? new Date(selectedRecord.previousWorkDetails?.startDate).toISOString().split('T')[0]
            : ''
        },
        {
          key: 'prevEndDate',
          value: selectedRecord?.previousWorkDetails?.endDate
            ? new Date(selectedRecord.previousWorkDetails?.endDate).toISOString().split('T')[0]
            : ''
        },
        { key: 'prevRole', value: selectedRecord?.previousWorkDetails?.role },
        // Salary Details
        { key: 'baseSalary', value: selectedRecord?.salaryDetails?.baseSalary },
        { key: 'commissionPercentage', value: selectedRecord?.salaryDetails?.commissionPercentage },
        { key: 'contractSalary', value: selectedRecord?.salaryDetails?.contractSalary },
        { key: 'daPercentage', value: selectedRecord?.salaryDetails?.daPercentage },
        { key: 'esiPercentage', value: selectedRecord?.salaryDetails?.esiPercentage },
        { key: 'hourlyRate', value: selectedRecord?.salaryDetails?.hourlyRate },
        { key: 'hraPercentage', value: selectedRecord?.salaryDetails?.hraPercentage },
        { key: 'isEligibleForOvertime', value: selectedRecord?.salaryDetails?.isEligibleForOvertime },
        { key: 'pfPercentage', value: selectedRecord?.salaryDetails?.pfPercentage },
        { key: 'salaryType', value: selectedRecord?.salaryDetails?.salaryType },
        { key: 'taAmount', value: selectedRecord?.salaryDetails?.taAmount },
        { key: 'tdsPercentage', value: selectedRecord?.salaryDetails?.tdsPercentage },

        // Work Details
        { key: 'assignedShift', value: selectedRecord?.workDetails?.assignedShift?._id },
        { key: 'employeeId', value: selectedRecord?.workDetails?.employeeId },
        { key: 'department', value: selectedRecord?.workDetails?.department?._id },
        { key: 'role', value: selectedRecord?.workDetails?.role?._id },
        { key: 'currentStatus', value: selectedRecord?.workDetails?.currentStatus },

        //Address
        { key: 'addressLine1', value: selectedRecord?.address?.addressLine1 },
        { key: 'city', value: selectedRecord?.address?.city },
        { key: 'state', value: selectedRecord?.address?.state },
        { key: 'country', value: selectedRecord?.address?.country },
        { key: 'postalCode', value: selectedRecord?.address?.postalCode },
        { key: 'addressLine2', value: selectedRecord?.address?.addressLine2 },
        // Current Status and Date of Joining
        {
          key: 'dateOfJoining',
          value: selectedRecord?.workDetails?.dateOfJoining
            ? new Date(selectedRecord.workDetails?.dateOfJoining).toISOString().split('T')[0]
            : ''
        }
      ];
      if (selectedRecord?.personalInfo?.photo || selectedRecord?.documents?.proofOfIdentity) {
        // Create an object to hold both the photo and proofOfIdentity previews
        const updatedPreview = {};

        // If photo exists, add it to the updatedPreview
        if (selectedRecord?.personalInfo?.photo) {
          const photoUrl = `${BASE_URL_FOR_FILE}/${selectedRecord.personalInfo.photo}`;
          updatedPreview.photo = { url: photoUrl, name: selectedRecord.personalInfo.photo, type: 'image/jpeg' };
        }

        // If proofOfIdentity exists, add it to the updatedPreview
        if (selectedRecord?.documents?.proofOfIdentity) {
          const proofOfIdentityUrl = `${BASE_URL_FOR_FILE}/${selectedRecord.documents.proofOfIdentity}`;
          updatedPreview.proofOfIdentity = {
            url: proofOfIdentityUrl,
            name: selectedRecord.documents.proofOfIdentity,
            type: 'image/jpeg'
          };
        }

        // Set both photo and proofOfIdentity in imagePreview state
        setImagePreview(updatedPreview);
      }
      // Set values for all the fields
      fieldsToSet.forEach(({ key, value }) => {
        setValue(key, value);
      });
    } else {
      reset();
    }
  }, [selectedRecord, setValue, reset]);



  const formSubmit = async (formValues) => {
    const validateForm = () => {
      // Initialize an array to hold errors
      let errors = [];
      // Check each field and if enabled, ensure it has a value
      if (['new', 'edit'].includes(currentAction)) {
        // Salary Type is a mandatory field and should be checked
        if (!salaryTypeWatch) {
          errors.push('Salary Type is required.');
        }

        // Base Salary validation
        if (salaryTypeWatch === 'Permanent' && !formValues.baseSalary) {
          errors.push('Base Salary is required for Permanent salary type.');
        }

        // D/A % validation
        if (salaryTypeWatch === 'Permanent' && !formValues.daPercentage) {
          errors.push('D/A % is required for Permanent salary type.');
        }

        // T/A Amount validation
        if (salaryTypeWatch === 'Permanent' && !formValues.taAmount) {
          errors.push('T/A Amount is required for Permanent salary type.');
        }

        // HRA % validation
        if (salaryTypeWatch === 'Permanent' && !formValues.hraPercentage) {
          errors.push('HRA % is required for Permanent salary type.');
        }

        // PF % validation
        if (salaryTypeWatch === 'Permanent' && !formValues.pfPercentage) {
          errors.push('PF % is required for Permanent salary type.');
        }

        // ESI % validation
        if (salaryTypeWatch === 'Permanent' && !formValues.esiPercentage) {
          errors.push('ESI % is required for Permanent salary type.');
        }

        // Per Visit Rate validation
        if (salaryTypeWatch === 'Per Visit' && !formValues.perVisitRate) {
          errors.push('Per Visit Rate is required for Per Visit salary type.');
        }

        // Commission % validation
        if (salaryTypeWatch === 'Commission' && !formValues.commissionPercentage) {
          errors.push('Commission % is required for Commission salary type.');
        }

        // Hourly Rate validation
        if (salaryTypeWatch === 'Hourly' && !formValues.hourlyRate) {
          errors.push('Hourly Rate is required for Hourly salary type.');
        }

        // Contract Salary validation
        if (salaryTypeWatch === 'Contractual' && !formValues.contractSalary) {
          errors.push('Contract Salary is required for Contractual salary type.');
        }

        // Contract Salary validation
        if (salaryTypeWatch === 'Per Visit + Commission') {
          if (!formValues.perVisitRate) {
            errors.push('Per Visit Rate  is required');
          } else if (!formValues.commissionPercentage) {
            errors.push('Commission is required ');
          }
        }

        // Eligible For Over Time (if applicable)
        // if (salaryTypeWatch === 'Permanent' && formValues.isEligibleForOvertime === undefined) {
        //   errors.push('Eligible For Over Time is required for Permanent salary type.');
        // }
      }
      // If there are errors, alert the user
      if (errors.length > 0) {
        alert(errors.join('\n'));
        return false; // Prevent submission if validation fails
      }
      return true;
    };
    if (validateForm()) {
      setLoading(true);
      let editFlag = false;
      if (selectedRecord && currentAction === 'edit') {
        editFlag = true;
      }

      const formData = new FormData();
      Object.keys(formValues).forEach((key) => {
        formData.append(key, formValues[key]);
      });
      formData.append('createdBy', user.name);
      formData.append('updatedBy', editFlag ? user.name : '');
      formData.append('organisation', organisation);
      Object.keys(imageFile).forEach((id) => {
        formData.append(id, imageFile[id]);
      });

      formData.forEach((value, key) => {
        console.log(key, value);
      });
      try {
        if (!editFlag) {
          const response = await axios.post(`${BASE_URL}/employee/create`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          if (!response?.data?.success) {
            toast(`${response?.message}`, { variant: 'warning' });
          }
          if (response?.data?.success) {
            toast(`Successfully created Employee`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            setSelectedRecord();
          } else {
            toast(`Failed to createEmployee`, { variant: 'error' });
          }
        } else if (editFlag) {
          const response = await axios.put(`${BASE_URL}/employee/update/${selectedRecord?._id}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          if (!response?.data?.success) {
            toast(`${response?.message}`, { variant: 'warning' });
          }
          if (response?.data?.success) {
            toast(`Successfully created Employee`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            setSelectedRecord();
          } else {
            toast(`Failed to createEmployee`, { variant: 'error' });
          }
        }
      } catch (error) {
        console.log(error);
        toast(`${error?.response?.data?.message}`, { variant: 'warning' });
      }
      setLoading(false);
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/employee-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Employee', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Employee', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/employee-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Employee', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to deleted Employee', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setDoctorDataObj({ loading: true });
    const response = await request('/employee-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter((item)=> item.status !== "deleted");
      setDoctorDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDoctorDataObj({ loading: false });
    }
  };

  // useEffect(() => {
  //   if (doctorDataObj.data && doctorDataObj.data.length > 0) {
  //     setOriginalData(doctorDataObj.data);
  //   }
  // }, [doctorDataObj.data]);

  useEffect(() => {
    handleDoctorSearch();
  }, [input]);

  const handleDoctorSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const response = await request('/employee-list', {
        method: 'GET',
        query: { uhid: lowercasedInput, name: lowercasedInput }
      });
      if (response.success && Array.isArray(response.data)) {
        setDoctorDataObj({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setDoctorDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setDoctorDataObj({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  const salaryTypeWatch = watch('salaryType');
  const isEligibleForOvertime = watch('isEligibleForOvertime');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const id = event.target.name;

    if (file) {
      if (file.type.startsWith('image')) {
        const url = URL.createObjectURL(file);

        setImageFile((prevState) => ({
          ...prevState, // Keep the previous state values
          [id]: file // Add/update the current file
        }));

        setImagePreview((prevState) => ({
          ...prevState, // Keep the previous preview state
          [id]: { url, name: file.name, type: file.type } // Add/update the preview
        }));
      }
    }
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Employee Management
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setImagePreview();
                    setImageFile();
                    const fileInput = document.querySelector('input[type="file"]');
                    if (fileInput) {
                      fileInput.value = ''; // Reset the file input field
                    }
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid item xs={12} sx={{ mb: 1 }}>
                <Typography variant="h5" fontWeight="bold">
                  Personal Information
                </Typography>
                <Divider />
              </Grid>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem', fontSize: '1.4rem' }}>
                    First Name
                  </Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="firstName"
                    inputRef={fieldOneRef}
                    placeholder="Enter First Name"
                    onKeyDown={(e) => handleKeyPress(e, fieldTwoRef)}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Last Name</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="lastName"
                    inputRef={fieldTwoRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldThreeRef)}
                    placeholder="Enter Last Name"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>DOB/Gender</Typography>
                  <TextField
                    sx={{ flex: 0.4, border: currentAction ? '0.5px solid red' : '' }}
                    name="dob"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    placeholder="dob"
                    type="date"
                    inputRef={fieldThreeRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldFourRef)}
                  />
                  <SelectTag
                    formControlSX={{ flex: 0.4, border: currentAction ? '0.5px solid red' : '' }}
                    name="gender"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    placeholder="Gender"
                    menus={GENDER_DROPDOWN}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Mobile No</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.64 }}
                    name="mobile"
                    placeholder="Enter Mobile No"
                  />
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.6 }}
                    name="WhatsAppNumber"
                    placeholder="Enter Whatsapp No."
                  />

                  {(methods.formState.errors.mobile || methods.formState.errors.WhatsAppNumber) && (
                    <>
                      {methods.formState.errors.mobile && (
                        <Typography color="error" sx={{ fontSize: '0.875rem', marginTop: '4px' }}>
                          {methods.formState.errors.mobile.message}
                        </Typography>
                      )}
                      {methods.formState.errors.WhatsAppNumber && (
                        <Typography color="error" sx={{ fontSize: '0.875rem', marginTop: '4px' }}>
                          {methods.formState.errors.WhatsAppNumber.message}
                        </Typography>
                      )}
                    </>
                  )}
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Father's Name</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="fatherName"
                    placeholder="Enter Father's Name"
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Email Id</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="email"
                    placeholder="Enter Email ID"
                    inputRef={fieldFiveRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldSixRef)}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Aadhar No</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="aadharNumber"
                    placeholder="Enter Aadhar No"
                    error={!!methods.formState.errors.aadharNumber}
                    helperText={
                      methods.formState.errors.aadharNumber ? methods.formState.errors.aadharNumber.message : ''
                    }
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Aadhar Photo</Typography>
                  <input
                    disabled={!['new', 'edit'].includes(currentAction)}
                    type="file"
                    onChange={handleFileChange}
                    name="proofOfIdentity"
                  />
                  {imagePreview && imagePreview.proofOfIdentity && (
                    <img
                      src={imagePreview.proofOfIdentity?.url}
                      alt={imagePreview.proofOfIdentity?.name}
                      style={{ maxWidth: '10%', maxHeight: '100px' }}
                    />
                  )}
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Employee Photo</Typography>
                  <input
                    disabled={!['new', 'edit'].includes(currentAction)}
                    type="file"
                    onChange={handleFileChange}
                    name="photo"
                  />
                  {imagePreview && imagePreview.photo && (
                    <img
                      src={imagePreview.photo?.url}
                      alt={imagePreview.photo?.name}
                      style={{ maxWidth: '10%', maxHeight: '100px' }}
                    />
                  )}
                </Stack>
              </Stack>

              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Typography variant="h5" fontWeight="bold">
                    Address Details
                  </Typography>
                  <Divider />
                </Grid>

                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Country</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      menus={[{ _id: 'IN', name: 'India' }]}
                      disabled={true}
                      name="country"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>State</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="state"
                      menus={getStatesByCountry(watch('country'))}
                      placeholder="Enter State"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>City</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="city"
                      menus={getCityByState(watch('country'), watch('state'))}
                      placeholder="Enter City"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.2} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Address 1</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="addressLine1"
                      placeholder="Enter Address 1"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Address 2</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="addressLine2"
                      placeholder="Enter Address 2"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Postal Code</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="postalCode"
                      placeholder="Enter Address 3"
                    />
                  </Stack>
                </Stack>

                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Button
                    variant="contained"
                    onClick={() => handleActiveTab(0)}
                    sx={{
                      my: 0,
                      mx: 1,
                      borderRadius: '4px',
                      fontWeight: 900,
                      backgroundColor: activeTab === 0 ? 'primary.main' : 'default',
                      color: activeTab === 0 ? 'white' : 'text.primary'
                    }}
                  >
                    Work Details
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleActiveTab(1)}
                    sx={{
                      my: 0,
                      mx: 1,
                      borderRadius: '4px',
                      fontWeight: 900,
                      backgroundColor: activeTab === 1 ? 'primary.main' : 'default',
                      color: activeTab === 1 ? 'white' : 'text.primary'
                    }}
                  >
                    Previous Work Details
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleActiveTab(2)}
                    sx={{
                      my: 0,
                      mx: 1,
                      borderRadius: '4px',
                      fontWeight: 900,
                      backgroundColor: activeTab === 2 ? 'primary.main' : 'default',
                      color: activeTab === 2 ? 'white' : 'text.primary'
                    }}
                  >
                    Salary Details
                  </Button>
                  <Divider />
                </Grid>
                {activeTab === 0 && (
                  <>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Emp ID</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="employeeId"
                          placeholder="Enter Employee ID"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.65, border: currentAction ? '0.5px solid red' : '' }}
                          menus={departmentDropdown.map((data) => ({ ...data, name: data?.name }))}
                          name="department"
                          placeholder="Enter Department"
                        />
                        <Button
                          sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                          variant="contained"
                          onClick={() => setDepartmentMasterDialogue(true)}
                          disabled={!['new', 'edit'].includes(currentAction)}
                        >
                          <AddIcon />
                        </Button>
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Role</Typography>
                        <SelectTag
                          formControlSX={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          name="role"
                          menus={roleDropdown.map((data) => ({ ...data, name: data?.name }))}
                          placeholder="Enter Employee Role"
                        />
                        <Button
                          sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                          variant="contained"
                          onClick={() => setRoleMasterDialogue(true)}
                          disabled={!['new', 'edit'].includes(currentAction)}
                        >
                          <AddIcon />
                        </Button>
                      </Stack>
                    </Stack>

                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Status</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="currentStatus"
                          placeholder="Enter Current Status"
                          menus={CURRENT_STATUS}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Assigned Shift</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.7, border: currentAction ? '0.5px solid red' : '' }}
                          name="assignedShift"
                          placeholder="Enter Assigned Shift"
                          menus={shiftDropdown.map((data) => ({ ...data, name: data.shiftName }))}
                        />
                        <Button
                          sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                          variant="contained"
                          onClick={() => setShiftMasterDialogue(true)}
                          disabled={!['new', 'edit'].includes(currentAction)}
                        >
                          <AddIcon />
                        </Button>
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Date of Joining</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="dateOfJoining"
                          placeholder="Enter Current Profile"
                          type="date"
                        />
                      </Stack>
                    </Stack>
                  </>
                )}

                {activeTab === 1 && (
                  <>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Prev Org</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          name="companyName"
                          placeholder="Enter Previous Company"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Role</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="prevRole"
                          placeholder="Enter Previous Job Role"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Start Date</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="prevStartDate"
                          placeholder="Enter Current Profile"
                          type="date"
                        />
                      </Stack>
                    </Stack>

                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>End Date</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          name="prevEndDate"
                          placeholder="Enter Previous Company"
                          type="date"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Description</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="prevDescription"
                          placeholder="Enter Description"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Leaving Reason</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="reasonForLeaving"
                          placeholder="Reason Of Leaving"
                        />
                      </Stack>
                    </Stack>
                  </>
                )}

                {activeTab === 2 && (
                  <>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Salary Type</Typography>
                        <SelectTag
                          formControlSX={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          name="salaryType"
                          placeholder="Enter Previous Company"
                          menus={SALARY_TYPE}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Base Salary</Typography>
                        <TextField
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            !salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="baseSalary"
                          placeholder="Enter Base Salary"
                          type="number"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>D/A %</Typography>
                        <TextField
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            !salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="daPercentage"
                          placeholder="Enter D/A Percent"
                          type="number"
                        />
                      </Stack>
                    </Stack>

                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>T/A Amount</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            !salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          name="taAmount"
                          placeholder="Enter T/A Amount"
                          type="number"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>HRA %</Typography>
                        <TextField
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            !salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="hraPercentage"
                          type="number"
                          placeholder="Enter HRA Percent"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>PF %</Typography>
                        <TextField
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            !salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="pfPercentage"
                          placeholder="Enter PF Percent"
                          type="number"
                        />
                      </Stack>
                    </Stack>
                    <Stack sx={{ mb: 0.3, width: '66.5%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>ESI %</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            !salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          name="esiPercentage"
                          placeholder="Enter ESI Percent"
                          type="number"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Per Visit Rate</Typography>
                        <TextField
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            salaryTypeWatch === 'Permanent' ||
                            !salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            !salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          sx={
                            { flex: 0.8, border: currentAction ? '0.5px solid red' : '' } ||
                            !salaryTypeWatch === 'Permanent'
                          }
                          name="perVisitRate"
                          type="number"
                          placeholder="Enter Per Visit Rate"
                        />
                      </Stack>
                      {/* <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Commission%</Typography>
                        <TextField
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            !salaryTypeWatch === 'Commission' ||
                            !salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          sx={
                            { flex: 0.8, border: currentAction ? '0.5px solid red' : '' } ||
                            !salaryTypeWatch === 'Permanent'
                          }
                          name="commissionPercentage"
                          placeholder="Enter Commission Percent"
                          type="number"
                        />
                      </Stack> */}
                    </Stack>
                    <Stack
                      sx={{ mb: 0.3, width: salaryTypeWatch === 'Permanent' ? '100%' : '66.5%' }}
                      direction="row"
                      spacing={2}
                    >
                      {/* {salaryTypeWatch === 'Permanent' && (
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                          <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                            Eligible For Over Time
                          </Typography>
                          <Checkbox sx={{ flex: 0.8 }} name="isEligibleForOvertime" fontSize={22} />
                        </Stack>
                      )} */}
                      {/* <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Hourly Rate</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            (!isEligibleForOvertime &&
                              (salaryTypeWatch === 'Permanent' ||
                                salaryTypeWatch === 'Per Visit' ||
                                salaryTypeWatch === 'Commission' ||
                                salaryTypeWatch === 'Per Visit + Commission' ||
                                salaryTypeWatch === 'Contractual' ||
                                !salaryTypeWatch === 'Hourly'))
                          }
                          name="hourlyRate"
                          placeholder="Enter Hourly Rate"
                          type="number"
                        />
                      </Stack> */}
                      {/* <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Contract Salary</Typography>
                        <TextField
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            !salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          sx={
                            { flex: 0.8, border: currentAction ? '0.5px solid red' : '' } ||
                            !salaryTypeWatch === 'Permanent'
                          }
                          name="contractSalary"
                          type="number"
                          placeholder="Enter Contract Salary"
                        />
                      </Stack> */}
                    </Stack>
                    {/* <Stack sx={{ mb: 0.3, width: '65%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>TDS %</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            !salaryTypeWatch === 'Permanent' ||
                            salaryTypeWatch === 'Per Visit' ||
                            salaryTypeWatch === 'Commission' ||
                            salaryTypeWatch === 'Per Visit + Commission' ||
                            salaryTypeWatch === 'Contractual' ||
                            salaryTypeWatch === 'Hourly'
                          }
                          name="tdsPercentage"
                          placeholder="Enter TDS Percent"
                          type="number"
                        />
                      </Stack>  
                    </Stack> */}
                  </>
                )}
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Employee Management Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 10px'
                // fontSize: '14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Employees"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 1 }}
          columns={TABLE_COLUMNS}
          data={doctorDataObj?.data || []}
          // loading={originalData.loading}
          onRowClick={(row) => {
            setOpenQueryDialog(false);
            setSelectedRecord(row);
          }}
        />
      </Dialog>
      <Dialog
        open={departmentMasterDialogue}
        onClose={() => setDepartmentMasterDialogue(false)}
        PaperProps={{ sx: { width: '80%', height: '50vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={() => setDepartmentMasterDialogue(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Box>
        <DepartmentMaster
          getDepartmentDropdown={getDepartmentDropdown}
          setDepartmentMasterDialogue={setDepartmentMasterDialogue}
        />
      </Dialog>
      <Dialog
        open={roleMasterDialogue}
        onClose={() => setRoleMasterDialogue(false)}
        PaperProps={{ sx: { width: '80%', height: '50vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={() => setRoleMasterDialogue(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Box>
        <RoleMaster getRoleDropdown={getRoleDropdown} setRoleMasterDialogue={setRoleMasterDialogue} />
      </Dialog>

      <Dialog
        open={shiftMasterDialogue}
        onClose={() => setShiftMasterDialogue(false)}
        PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={() => setShiftMasterDialogue(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Box>
        <ShiftMaster getShiftDropdown={getShiftDropdown} setShiftMasterDialogue={setShiftMasterDialogue} />
      </Dialog>
    </>
  );
};
